import { createComponent, ComponentProps } from '@/internals/utils';
export type StatHelpTextProps = ComponentProps;

const StatHelpText = createComponent({ name: 'StatHelpText', componentAs: 'span' });

export default StatHelpText;
